import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import {
  increaseWeeklyLeaderboardScore,
  joinWeeklyLeaderboard,
} from './weeklyLeaderboard.modifiers';
import { getOngoingWeeklyLeaderboardEvent } from './weeklyLeaderboard.getters';

export const weeklyLeaderboardCheats = createActions({
  cheat_resetWeeklyLeaderboard: action((state, _, api) => {
    delete state.weeklyLeaderboard;
  }),
  cheat_joinWeeklyLeaderboard: action((state, _, api) => {
    joinWeeklyLeaderboard(state, api.date.now());

    if (!state.weeklyLeaderboard) {
      console.error('Failed to join weekly leaderboard');
      return;
    }

    const event = getOngoingWeeklyLeaderboardEvent(state, api.date.now());
    if (!event) return;

    const entry = state.weeklyLeaderboard.entries[event.id];
    if (!entry) return;
    // Reset opponents so that they can be fetched again
    entry.joinedAt = api.date.now();
    entry.opponents = [];
  }),

  cheat_increaseWeeklyLeaderboardScore: action(
    (state, args: { score: number }, api) => {
      increaseWeeklyLeaderboardScore(state, args.score, api.date.now());
    },
  ),
  cheat_setWinStreak: action((state, streak: number, api) => {
    state.match2.winStreak = streak;
    state.match2.buruStreak.value = streak;
  }),
});
